<template>
  <BusinessCrud
    title="PC视频中心"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getPcVideoList"
    :save-api="savePcVideo"
    :delete-api="deletePcVideo"
    :defaults="{ source: '锐高', coverImage: '', sortOrder: 0, isTop: 0, viewCount: 0, status: 1 }"
    :modal-width="860"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getPcVideoList, savePcVideo, deletePcVideo } from '@/api'

export default {
  name: 'PcVideoAdmin',
  components: { BusinessCrud },
  data() {
    return {
      getPcVideoList,
      savePcVideo,
      deletePcVideo,
      searchFields: [
        { key: 'title', label: '视频标题' },
        { key: 'status', label: '状态', type: 'select', options: [{ label: '显示', value: 1 }, { label: '隐藏', value: 0 }] }
      ],
      columns: [
        { title: '视频标题', dataIndex: 'title' },
        { title: '来源', dataIndex: 'source', width: 120 },
        { title: '推荐', dataIndex: 'isTop', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '播放量', dataIndex: 'viewCount', width: 90 },
        { title: '排序', dataIndex: 'sortOrder', width: 80 },
        { title: '状态', dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } }
      ],
      formFields: [
        { key: 'title', label: '视频标题' },
        { key: 'summary', label: '摘要', type: 'textarea', rows: 3 },
        { key: 'coverImage', label: '封面图', type: 'upload-image' },
        { key: 'videoUrl', label: '视频文件', type: 'upload-video' },
        { key: 'source', label: '来源' },
        { key: 'sortOrder', label: '排序', type: 'number', min: 0 },
        { key: 'isTop', label: '是否推荐', type: 'switch' },
        { key: 'status', label: '状态', type: 'switch' }
      ]
    }
  }
}
</script>
